<template>
  <div>
    <div class="row d-flex justify-content-around">
      <div class="col-md-6 form-group">
        <label for="matiere_id" class="ml-3">Choisir une matière</label>
        <select
          name="matiere_id"
          v-model="matiere"
          class="form-control selectpicker"
          data-live-search="true"
          data-size="7"
          data-style="select-with-transition"
          title="Select Matière"
          @change.prevent="activitie_details($event)"
        >
          <option
            style="width: 97%"
            v-for="matiere in matieres"
            :key="`matiere_${matiere.id}`"
            :value="matiere.id"
          >
            {{
              matiere.service_id +
              "/" +
              matiere.serviceoff_id +
              " : " +
              matiere.nom
            }}
          </option>
        </select>
      </div>
    </div>
    <div class="modal-table mb-4">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">TYPE</th>
            <th scope="col">VOLUME</th>
            <th scope="col">TAUX</th>
            <th scope="col" class="text-right">
              <span class="prix-max btn btn-dark font-weight-bold btn-pill"
                >{{ heurs_rest }}H MAX
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="bg-grey"
            v-for="(detail, index) in details"
            :key="`detail_${index}`"
          >
            <td>
              <input
                v-model="detail.type"
                id="type"
                name="type"
                style="margin-top: 0px"
                class="kt_select2 form-control"
                data-size="7"
                data-style="select-with-transition"
                title=" Select Type"
                disabled
              />
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  v-model="detail.volume_horaire"
                  class="form-control"
                  placeholder="Volume Horaire"
                  @change="updateVH(detail, index)"
                />
                <div class="input-group-append">
                  <span class="input-group-text">H</span>
                </div>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  v-model="detail.taux"
                  type="text"
                  class="form-control"
                  placeholder="Taux"
                  disabled
                />
                <div class="input-group-append">
                  <span class="input-group-text">DH</span>
                </div>
              </div>
            </td>
            <!-- <td>
              <button
                type="button"
                v-if="
                  detail.type != NULL &&
                  detail.volume_horaire != NULL &&
                  detail.taux != NULL
                "
                class="btn-plus btn btn-sm btn-icon btn-secondary btn-circle"
              >
                <i
                  aria-hidden="true"
                  @click="ajouter(index)"
                  class="fa fa-pen"
                ></i>
              </button>
            </td> -->
          </tr>

          <input type="hidden" name="details" v-model="data" />
          <!-- <tr v-for="(detail, index) in details" :key="`detail_${index}`">
            <td>{{ detail.type }}</td>
            <td>{{ detail.volume_horaire }}</td>
            <td>{{ detail.taux }}</td>
            <td>
              <a
                class="btn-minus btn btn-sm btn-icon btn-secondary btn-circle"
                @click="supprimer(index)"
                href="#"
              >
                <i class="fas fa-minus"></i>
              </a>
            </td>
          </tr> -->
          <tr style="text-align: center" v-if="!details.length">
            <td colspan="4">Aucun détail trouvé…</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="form-group">
      <label for="autre">Autre</label>
      <textarea
        v-model="autre"
        class="form-control"
        name="autre"
        id="autre"
        rows="3"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    matieres: Array,
    types: Array,
    heurs_rest: 0,
    acte_engagement: {},
  },
  data() {
    return {
      matiere: null,
      volume_horaire: null,
      taux: null,
      type: null,
      details: [],
      data: [],
      autre: null,
      matiere_id: null,
    };
  },
  created() {},
  methods: {
    ajouter(index) {
      this.details.push({
        volume_horaire: this.volume_horaire,
        taux: this.taux,
        type: this.type,
      });
      this.details.pop(index);
    },
    supprimer(index) {
      this.details.pop(index);
    },
    activitie_details(event) {
      axios
        .get(
          "/api/activitie/details/" +
            this.acte_engagement.id +
            "/" +
            event.target.value
        )
        .then((response) => {
          this.details = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateVH(detail, index) {
      var old_vh = detail.volume_horaire;
      if (this.volume_horaire > old_vh) {
        alert.pop("vh problem");
      } else {
        this.details.push({
          volume_horaire: detail.volume_horaire,
          taux: detail.taux,
          type: detail.type,
        });
        this.details.pop(index);
      }
    },
  },

  watch: {
    details: function (val) {
      this.data = JSON.stringify(this.details);
    },
  },
};
</script>

<style>
</style>
